import { Utils } from "../../../../../../../services/utils.service";
import { DataCollection } from "../../../../../../infrastructure/datacollection";
import { DataContainerService } from "../../../../../../infrastructure/datacontainer.service";
import { RequestTypes } from "../../../../../../infrastructure/enums";
import { TransportData } from "../../../../../../infrastructure/transportdata";

export class AFPostMasterFetchRequest {
    public static readonly FetchRequestType: string = "af_post_fetch_request";
zone_ids: number[] = [];
district_ids: number[] = [];
block_ids: number[] = [];
bcm_post_ids: number[] = [];
phc_ids: number[] = [];

    public MergeIntoTransportData = (td: TransportData) => {
        let coll = DataContainerService.GetInstance().GetOrCreateCollection(td.MainData, AFPostMasterFetchRequest.FetchRequestType) as DataCollection;
        coll.Entries.push(this);
    }

    public FormulateTransportData = () => {
        let td = Utils.GetInstance().CreateNewTransportData(RequestTypes.Fetch);
        this.MergeIntoTransportData(td);

        return td;
    }
}

export class AFPostNameFetchRequest {
    public static readonly FetchRequestType: string = "af_post_name_fetch_request";
    zone_ids: number[] = [];
district_ids: number[] = [];
block_ids: number[] = [];
bcm_post_ids: number[] = [];
phc_ids: number[] = [];

    public MergeIntoTransportData = (td: TransportData) => {
        let coll = DataContainerService.GetInstance().GetOrCreateCollection(td.MainData, AFPostNameFetchRequest.FetchRequestType) as DataCollection;
        coll.Entries.push(this);
    }

    public FormulateTransportData = () => {
        let td = Utils.GetInstance().CreateNewTransportData(RequestTypes.Fetch);
        this.MergeIntoTransportData(td);

        return td;
    }
}

